module.exports = __webpack_public_path__ + "img/emoji_30.b9ab6903.png";